export function currentEnv() {
    const target = process.env.VERCEL_TARGET_ENV;
    const vercelEnv = process.env.VERCEL_ENV;
    const publicVercelEnv = process.env.NEXT_PUBLIC_VERCEL_ENV;
    const publicTarget = process.env.NEXT_PUBLIC_VERCEL_TARGET_ENV;
    // Vercel custom environments deploy with VERCEL_ENV=production; the target
    // slug is the only reliable way to distinguish staging from true prod.
    if (target === 'staging')
        return 'staging';
    if (vercelEnv === 'production')
        return 'production';
    if (vercelEnv === 'preview')
        return 'preview';
    if (vercelEnv === 'development')
        return 'development';
    // Client-side code can only rely on NEXT_PUBLIC_* values. Do not use this
    // branch for server-side production safety gates; it is for analytics/UI only.
    if (publicTarget === 'staging')
        return 'staging';
    if (publicVercelEnv === 'production')
        return 'production';
    if (publicVercelEnv === 'preview')
        return 'preview';
    if (publicVercelEnv === 'development')
        return 'development';
    return 'local';
}
export function isProduction() {
    return currentEnv() === 'production';
}
export function isSyntheticDataEnv() {
    return currentEnv() !== 'production';
}
